import { AiMessagesPromptTypes } from '@/constants/AI.js';

export const AiContextType = {
    MODULE: 'module',
    SECTION: 'section',
    PAGE: 'page',
};

export const THEME_TITLE_MAX_LENGTH = 2000;
export const THEME_DESCRIPTION_MAX_LENGTH = 2000;
export const DEFAULT_CONTEXT_TYPE = AiContextType.MODULE;

export const HISTORY_ITEM_DATA_MAP = {
    [AiMessagesPromptTypes.IMPROVE_WRITING]: {
        text: 'Улучши текст в проекте',
        type: 'Улучшить текст',
        icon: require('@/components/WysiwygRedactor/assets/icons/icons8-magic-wand.svg'),
    },
    [AiMessagesPromptTypes.CORRECT_WRITING]: {
        text: 'Исправь правописание выделенного в проекте',
        type: 'Исправить правописание',
        icon: require('@/components/WysiwygRedactor/assets/icons/icons8-clipboard-check.svg'),
    },
    [AiMessagesPromptTypes.MAKE_SHORTER]: {
        text: 'Сделай короче текст в проекте',
        type: 'Сделать короче',
        icon: require('@/components/WysiwygRedactor/assets/icons/icons8-short-text.svg'),
    },
    [AiMessagesPromptTypes.MAKE_LONGER]: {
        text: 'Сделай длиннее текст в проекте',
        type: 'Сделать длиннее',
        icon: require('@/components/WysiwygRedactor/assets/icons/icons8-word-wrap.svg'),
    },
    [AiMessagesPromptTypes.SUMMARIZE]: {
        text: 'Подведи итог из выделенного в проекте',
        type: 'Подвести итог',
        icon: require('@/components/WysiwygRedactor/assets/icons/icons8-quote-term.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_INCORRECT_ANSWERS]: {
        text: 'Создай неправильные ответы для вопроса в тесте проекта',
        type: 'Неправильные ответы',
        icon: require('@editor-settings/assets/icons/icons8-delete-talk-alt.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_IMAGE]: {
        text: 'Создай картинку для проекта',
        type: 'Изображение',
        icon: require('@/assets/svg/icons8-image.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_TASK]: {
        text: 'Создай задание для проекта',
        type: 'Придумать задание',
        icon: require('@/components/WysiwygRedactor/assets/icons/icon-edit-property.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_CONSOLIDATE_MATERIAL_TASK]: {
        text: 'Создай задание для проекта',
        type: 'Придумать задание',
        icon: require('@/components/WysiwygRedactor/assets/icons/icon-edit-property.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_TESTING_SKILLS_TASK]: {
        text: 'Создай задание для проекта',
        type: 'Придумать задание',
        icon: require('@/components/WysiwygRedactor/assets/icons/icon-edit-property.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_REFLECTION_ON_MATERIAL_TASK]: {
        text: 'Создай задание для проекта',
        type: 'Придумать задание',
        icon: require('@/components/WysiwygRedactor/assets/icons/icon-edit-property.svg'),
    },
    [AiMessagesPromptTypes.MAKE_QUESTION]: {
        text: 'Ответь на вопрос в проекте',
        type: 'Чат с GigaChat',
        icon: require('@/components/WysiwygRedactor/assets/icons/icon-question-bubble.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_TEST]: {
        text: 'Создай тест для проекта',
        type: 'Создать тест',
        icon: require('@/components/WysiwygRedactor/assets/icons/ic_report-card.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_TEST_QUESTION]: {
        text: 'Создай вопрос в тесте проекта',
        type: 'Создать тест',
        icon: require('@/components/WysiwygRedactor/assets/icons/ic_tick-box.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_RECOGNIZE_SYMBOLS]: {
        text: 'Распознай символы с изображения в проекте',
        type: 'Распознать символы',
        icon: require('@/components/WysiwygRedactor/assets/icons/ic_ic_recognize2.svg'),
    },
    [AiMessagesPromptTypes.GENERATE_QUOTE]: {
        text: 'Создай цитату в проекте',
        type: 'Найти цитату',
        icon: require('@/components/WysiwygRedactor/assets/icons/ic_quote.svg'),
    },
};

export const mimePasteToExtMap = {
    'image/png': 'png',
    'image/jpeg': 'jpeg',
    'image/jpg': 'jpg',
    'image/bmp': 'bmp',
};

export const acceptPasteExtensions = Object.values(mimePasteToExtMap);
